import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { AccountEffectsModule } from '@appStore/account/effects';
import { reducers } from '@appStore/account/reducers';
import * as fromServices from '@appStore/account/services';

export * from '@appStore/account/reducers';
export * from '@appStore/account/effects';
export * from '@appStore/account/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('account', reducers), AccountEffectsModule],
  providers: [...fromServices.services]
})
export class AccountStoreModule {}
